import React from 'react';

import SimpleMessagePage from 'components/SimpleMessagePage';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';

const UnifiedPending: React.FC = () => {
  const tMd = useMarkdownTranslate();
  return (
    <SimpleMessagePage
      headerTitle={'unified.placeOrder.error.pending.title'}
      message={tMd('unified.placeOrder.error.pending.message')}
    ></SimpleMessagePage>
  );
};

export default UnifiedPending;
